import {
    ChevronsLeft,
    ChevronLeft,
    ChevronRight,
    ChevronsRight,
    ChevronDown
} from "lucide-react";
import { memo } from "react";


function CustomPagination(props) {
    const {
        setCurrentPage,
        currentPage,
        accessCodeList,
        pageSize,
        setPageSize,
    } = props;

    const totalPages = Math.ceil(accessCodeList.length / pageSize);
    const isFirstPage = currentPage === 1;
    const isLastPage = currentPage >= totalPages;

    return (
        <div className="pagination-wrapper">
            <div className="pagination-nav">
                {/* First */}
                <button
                    className={`page-nav-link ${isFirstPage ? "disabled" : ""}`}
                    disabled={isFirstPage}
                    onClick={() => setCurrentPage(1)}
                >
                    <ChevronsLeft size={16} />
                </button>

                {/* Prev */}
                <button
                    className={`page-nav-link ${isFirstPage ? "disabled" : ""}`}
                    disabled={isFirstPage}
                    onClick={() => setCurrentPage((p) => p - 1)}
                >
                    <ChevronLeft size={16} />
                </button>

                {/* Current Page */}
                <span className="page-number">{currentPage}</span>

                {/* Next */}
                <button
                    className={`page-nav-link ${isLastPage ? "disabled" : ""}`}
                    disabled={isLastPage}
                    onClick={() => setCurrentPage((p) => p + 1)}
                >
                    <ChevronRight size={16} />
                </button>

                {/* Last */}
                <button
                    className={`page-nav-link ${isLastPage ? "disabled" : ""}`}
                    disabled={isLastPage}
                    onClick={() => setCurrentPage(totalPages)}
                >
                    <ChevronsRight size={16} />
                </button>
            </div>

            {/* Page Size */}
            <div className="page-select-wrapper">
                <select
                    className="page-select"
                    value={pageSize}
                    onChange={(e) => {
                        setPageSize(Number(e.target.value));
                        setCurrentPage(1);
                    }}
                    disabled={accessCodeList?.length <= 200}
                >
                    <option value={200}>200</option>
                    <option value={500}>500</option>
                    <option value={1000}>1000</option>
                </select>
                <ChevronDown class="page-select-icon" />
            </div>
        </div>
    );
}

export default memo(CustomPagination);
